<header>
  <button (click)="modalClose()" aria-label="Close" inlineSVG="/assets/icons/close.svg" class="modal-close" data-testid="modal-close-btn"></button>
  <h1 class="modal-title">{{ modalTitle }}</h1>
</header>

<form *ngIf="isForm; else noFormVersion">
  <ng-container *ngTemplateOutlet="modalBody"></ng-container>
</form>

<ng-template #noFormVersion>
  <ng-container *ngTemplateOutlet="modalBody"></ng-container>
</ng-template>

<ng-template #modalBody>
  <ng-content></ng-content>
  <footer class="modal-actions" *ngIf="enableFooter">
    <button
      *ngFor="let action of actions"
      [class.close]="action.type === type.Close"
      [class.positive]="action.type === type.Positive"
      [class.destructive]="action.type === type.Destructive"
      (click)="action.action()"
      [type]="isForm && (action.type !== type.Close) ? 'submit' : 'button'"
      [disabled]="action.type !== type.Close ? actionDisabled : false"
      [attr.data-testid]="action.label | function: buttonTestId"
    >
      <svg *ngIf="action.svg" [inlineSVG]="action.svg"></svg>
      {{ action.label }}
    </button>
  </footer>
</ng-template>
